module.exports = __webpack_public_path__ + "assets/details-shares.e03cd2a3.svg";